import PropTypes from "prop-types";

const BookingStep5 = (props) => {
 return (
    <React.Fragment>
      <div className="please-sele">
        <h1>
          Step5
        </h1>
      </div>
    </React.Fragment>
  );
};

BookingStep5.propTypes = {
  isBookingStep: PropTypes.number,
  isBookingSelectedServicesData: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
};
export default BookingStep5;